module.exports = __webpack_public_path__ + "static/img/073_TO8_1700_og.7a64810.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/073_TO8_1700_og.jpg
// module id = BAtJ
// module chunks = 0